module.exports = __webpack_public_path__ + "img/20190808170841QQ截图20190808022724.f9bba018.png";